import * as React from "react";
import { generateArticleData } from "../lib/generateArticleData";
import { IArticleData } from "../utils/interfaces/common/XArticle.interfaces";
import { TApiFetcherArticlesArgs, useXoraiaValue } from "./useXoraia";
import { isEqual } from "lodash";

export const useArticles = (args?: TApiFetcherArticlesArgs) => {
  const { apiFetcher, env, businessId } = useXoraiaValue();
  const [articles, setArticles] = React.useState<IArticleData[]>();
  const [lastArgs, setLastArgs] = React.useState<TApiFetcherArticlesArgs>();

  React.useEffect(() => {
    const getArticles = async () => {
      const limit = args?.limit ?? 0;
      // const length = (articles ?? []).length;

      const notChanged =
        // ((env === "prod" && articles) || (limit === length && env === "dev")) &&
        isEqual(lastArgs, args);

      if (!apiFetcher || !apiFetcher.articles || notChanged) {
        return;
      }

      try {
        let _articles = await apiFetcher.articles({ ...args, businessId });

        if (_articles.length === 0 && env === "dev") {
          _articles = generateArticleData(limit > 0 ? limit : 1);
        }

        setArticles(_articles);

        setLastArgs(args);
      } catch (error) {
        console.error("GET OPT =>", error);
      }
    };

    getArticles();
  }, [args]);

  return { articles: articles ?? [], setArticles };
};
